export default __webpack_public_path__ + "static/risk-eb78780587804a5ead0fc44b838be2f4.png";